





























































import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import api from '@/infrastructure/api/api';
import {卸比較商品型} from '@/type/estimates/comparison';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import {卸型} from '@/type/wholesale/wholesale';
import {progress} from '@/script/progress';
import {入札Excel取込結果型} from '@/type/estimates/comparison.ts';

@Component({
  components: {
    NormalDialog,
    AlertDialog,
  },
})
export default class ComparisonExcelDialog extends Vue {
  @Prop({default: false})
  modal!: boolean;
  @Prop({default: []})
  wholesales!: 卸型[];

  処理方法: string = '作成';
  作成条件: string = '全商品';
  卸コード: string = this.デフォルト卸コード;
  取込ファイル: File | null = null;

  入札Excel取込結果: 入札Excel取込結果型 | null = null;
  取込結果メッセージ: string[] = [];
  アラートメッセージ: string[] | string | null = null;

  @Watch('modal')
  changeDialog(nowModal: boolean, prevModal: boolean): void {
    if (nowModal) {
      this.卸コード = this.デフォルト卸コード;
      this.入札Excel取込結果 = null;
      this.取込結果メッセージ = [];
      this.openDialog('卸比較Excel');
    }
  }

  @Emit()
  closeExcelDialog(): void {
    this.closeDialog('卸比較Excel');
  }

  @Emit()
  async exportForWholesale(卸コード: string, 作成区分: string): Promise<void> {
    return;
  }

  @Emit()
  async reload() {
    return;
  }

  // computed
  get デフォルト卸コード(): string {
    if (this.wholesales.length === 0) {
      return '';
    }
    return this.wholesales[0].卸コード;
  }

  get 確定可能である(): boolean {
    if (this.処理方法 === '作成') {
      return true;
    }
    return this.アップロード可能である;
  }

  get 取込である(): boolean {
    return this.処理方法 === '取込';
  }

  get アップロード可能である(): boolean {
    if (this.取込ファイル === null) {
      return false;
    }
    if (this.取込ファイル.size > this.アップロード制限サイズ) {
      return false;
    }
    return true;
  }

  get アップロード制限サイズ(): number {
    return 30 * this.メガバイト; // 30MB以上は禁止
  }

  get メガバイト(): number {
    return 1024 * 1024;
  }

  get 取込完了である(): boolean {
    if (this.入札Excel取込結果 == null) {
      return false;
    }
    return this.入札Excel取込結果.取込完了;
  }

  // method
  openDialog(name: string): void {
    this.$modal.show(name);
  }

  closeDialog(name: string): void {
    this.$modal.hide(name);
  }

  async 確定する(): Promise<void> {
    if (this.処理方法 === '作成') {
      this.exportForWholesale(this.卸コード, this.作成条件);
      this.closeExcelDialog();
    }
    if (this.処理方法 === '取込') {
      await progress(this.取込);
    }
  }

  async 取込(): Promise<void> {
    if (!this.取込ファイル) {
      return;
    }
    if (!this.アップロード可能である) {
      return;
    }
    const params = new FormData();
    params.append('file', this.取込ファイル);
    await api.未確定入札Excelを取込する(params)
      .then((response) => {
        this.入札Excel取込結果 = response;
        this.取込結果メッセージ = response.エラーメッセージリスト;
        this.reload();
      }).catch((error) => {
        if (error.data.errors) {
          this.showAlert(error.data.errors);
        }
        if (error.data.message && !error.data.errors) {
          this.showAlert([error.data.message]);
        }
      });
  }

  selectedFile(event: any) {
    const files: FileList = event.target.files;
    if (0 < files.length) {
      this.取込ファイル = files.item(0);
    }
    this.取込ファイル = files.item(0);
    if (this.取込ファイル && this.取込ファイル.size > this.アップロード制限サイズ) {
      this.showAlert('ファイルのアップロードは' + (this.アップロード制限サイズ / this.メガバイト) + 'MB 以下にしてください');
    }
  }

  showAlert(message: string[] | string | null): void {
    this.アラートメッセージ = message + '。取込を中止しました。';
    this.$modal.show('ファイルアップロードアラートダイアログ');
  }

  // lifecycle hook
}
